import { Component, HostListener, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';
import { Observable, forkJoin } from 'rxjs';
import { PropietarioService } from '../../../../shared/services/propietarios.service';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import { Utils } from '../../../../shared/utils/Utils';
const Swal = require("sweetalert2");
import * as data from '../../../../shared/data/dashboard/social'
import * as bootstrap from 'bootstrap';
import { gpcGoogleService } from '../../../../shared/services/gpcGoogle.service';
import { AdministracionService } from '../../../../shared/services/administracion.services';
import { Administracion } from '../../../../shared/model/administracion.model';
import { AuthService } from '../../../../shared/services/auth.service';
@Component({
  selector: 'app-licencia',
  templateUrl: './licencia.component.html',
  styleUrls: ['./licencia.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LicenciaComponent implements OnInit {
  public facebook = data.facebook;
  public selected = [];

  public searchText = ''; // Texto para búsqueda
  total$: Observable<number>; // Observable para obtener el total de elementos
  propietarios: any[] = [];


  public show: boolean = false
  openDropdown: any = null; // Variable para controlar qué menú está abierto
  openDropdown2: any = null; // Variable para controlar qué menú está abierto
  sortColumn: string = '';
  sortDirection: string = 'asc'; // 'asc' o 'desc'
  searchTerm: string = '';
  dropdownStates: boolean[] = [];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>; // Para la cabecera de la tabla
  estadisticas: {
    vigentes: number; porVencer: number; vencidos: number; porcentajeVencidos: number,
    porcentajeVigentes: number, porcentajePorVencer: number
  } = {
      vigentes: 0,
      porVencer: 0,
      vencidos: 0,
      porcentajeVencidos: 0,
      porcentajeVigentes: 0,
      porcentajePorVencer: 0,
    };
  tableItem$: any;
  filteredTableItems: PropietarioService[];
  cedula: string;
  loading: boolean = true;
  allFiles: any[] = [];
  files: any[] = [];
  previewFile: any = null;

  currentFileIndex = 0;
  administraciones: Administracion[] = [];


  constructor(
    private propietarioService: PropietarioService, 
     private administracionesServices: AdministracionService,     
      private gpcGoogle: gpcGoogleService,
      private auth: AuthService
  
  ) { }

  ngOnInit() {
    // Cargar datos en paralelo para mayor velocidad
    forkJoin({
      administraciones: this.administracionesServices.obtenerTodas(),
      licencias: this.propietarioService.getListadoLicencias()
    }).subscribe({
      next: ({ administraciones, licencias }) => {
        // Cargar administraciones
        this.administraciones = administraciones;
        
        // Cargar licencias
        if (licencias && licencias.data) {
          this.propietarios = licencias.data;
          this.filteredTableItems = [...this.propietarios];

          const {
            vigentes = 0,
            porVencer = 0,
            vencidos = 0,
            porcentajeVencidos = 0,
            porcentajeVigentes = 0,
            porcentajePorVencer = 0
          } = licencias.estadisticas || {};

          this.estadisticas = {
            vigentes,
            porVencer,
            vencidos,
            porcentajeVencidos,
            porcentajeVigentes,
            porcentajePorVencer
          };

          this.propietarioService.actualizarEstadisticas(this.estadisticas);
        } else {
          this.propietarios = [];
          this.filteredTableItems = [];
          this.estadisticas = {
            vigentes: 0,
            porVencer: 0,
            vencidos: 0,
            porcentajeVencidos: 0,
            porcentajeVigentes: 0,
            porcentajePorVencer: 0
          };
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error cargando datos:', err);
        this.propietarios = [];
        this.filteredTableItems = [];
        this.loading = false;
      }
    });
  }

  pageSize: number = 5;
  page: number = 1;
  totalItems: number;

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }

  stopPropagation(event: Event) {
    event.stopPropagation(); // Evita que el clic dentro del dropdown cierre el menú
  }
  // Función para ordenar las columnas
  onSort({ column, direction }: SortEvent) {
    // Restablecemos la dirección de orden de todas las columnas
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // Establecemos la columna y dirección de orden
    // this.service.sortColumn = column;
    // this.service.sortDirection = direction;
  }

  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    const listToSort = this.filteredTableItems.length ? this.filteredTableItems : this.propietarios;

    listToSort.sort((a, b) => {
      let aVal = this.getNestedValue(a, column);
      let bVal = this.getNestedValue(b, column);

      if (typeof aVal === 'string') aVal = aVal.toLowerCase();
      if (typeof bVal === 'string') bVal = bVal.toLowerCase();

      if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
      if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    this.page = 1; // Reiniciar paginación
  }

  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj) ?? '';
  }

  get filteredPropietarios() {
    if (!this.searchTerm) {
      return this.propietarios; // Mostrar todos los datos si no hay búsqueda
    }

    const term = this.searchTerm.toLowerCase();
    return this.propietarios.filter(propietario => {
      // Ajusta los campos por los que quieres buscar
      return (
        propietario.primernombre.toLowerCase().includes(term) ||
        propietario.segundonombre.toLowerCase().includes(term) ||
        propietario.papellidos.toLowerCase().includes(term) ||
        propietario.seapellidos.toLowerCase().includes(term) ||
        propietario.cedula.toLowerCase().includes(term) ||
        propietario.mail.toLowerCase().includes(term) ||
        propietario.numerolic.toLowerCase().includes(term) ||
        propietario.direccion.toLowerCase().includes(term) ||
        propietario.cargoData.cargos.toLowerCase().includes(term) ||
        propietario.condicionLaboral.label.toLowerCase().includes(term) ||
        propietario.telfijo.toLowerCase().includes(term) ||
        propietario.telcel.toLowerCase().includes(term)
      );
    });
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => (i === index ? !state : false));
  }



  
  listarLicencias(): void {
    this.loading = true;
    this.propietarioService.getListadoLicencias().subscribe({
      next: (data) => {
        if (data && data.data) {
          this.propietarios = data.data;

          // ✅ Inicializar elementos filtrados para el paginador
          this.filteredTableItems = [...this.propietarios];

          // Estadísticas con valores por defecto
          const {
            vigentes = 0,
            porVencer = 0,
            vencidos = 0,
            porcentajeVencidos = 0,
            porcentajeVigentes = 0,
            porcentajePorVencer = 0
          } = data.estadisticas || {};

          this.estadisticas = {
            vigentes,
            porVencer,
            vencidos,
            porcentajeVencidos,
            porcentajeVigentes,
            porcentajePorVencer
          };

          this.propietarioService.actualizarEstadisticas(this.estadisticas);
        } else {
          this.propietarios = [];
          this.filteredTableItems = []; // ✅ También limpiar aquí
          this.estadisticas = {
            vigentes: 0,
            porVencer: 0,
            vencidos: 0,
            porcentajeVencidos: 0,
            porcentajeVigentes: 0,
            porcentajePorVencer: 0
          };
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error cargando licencias', err);
        this.propietarios = [];
        this.filteredTableItems = []; // ✅ Manejo seguro en error
        this.loading = false;
      },
    });
  }

  getEstado(propietario: any): number {
    if (!propietario.vencelic) return 0; // Estado desconocido

    const hoy = new Date();
    const vencelic = new Date(propietario.vencelic);
    const diasRestantes = Math.ceil((vencelic.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24));

    if (diasRestantes < 0) {
      return 3; // VENCIDA
    } else if (diasRestantes <= 30) {
      return 2; // POR VENCER
    } else {
      return 1; // VIGENTE
    }
  }

  getDiasRestantes(vencelic: string): number {
    if (!vencelic) return NaN; // Manejar valores nulos o indefinidos

    const hoy = new Date();
    const fechaVencimiento = new Date(vencelic);
    const diferenciaDias = Math.ceil((fechaVencimiento.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24));

    return diferenciaDias;
  }

  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  // Convertir imagen a Base64
  getBase64Image(imgUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imgUrl;
      img.crossOrigin = "Anonymous"; // Evita problemas de CORS

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png")); // Convertir a Base64
      };

      img.onerror = (error) => reject(error);
    });
  }

selectedEstado: string = '';

filterData() {
  const search = this.searchText.toLowerCase();
  this.filteredTableItems = this.propietarios.filter((item) => {
    const matchesText = (
      item.primernombre +
      item.segundonombre +
      item.papellidos +
      item.seapellidos +
      item.cedula +
      item.numerolic +
      item.categoria +
      item.telcel +
      item.estadoLicencia
    )
      .toLowerCase()
      .includes(search);

    const matchesEstado = this.selectedEstado
      ? this.getEstado(item) === Number(this.selectedEstado)
      : true;

    return matchesText && matchesEstado;
  });

  this.page = 1; // Reiniciar a la primera página
}

filterData1() {
  this.filterData(); // Usa el mismo método para combinar búsqueda y estado
}


  async loadFiles(cedula: string) {
    this.loading = true;
    try {
      
      const res: any = await this.gpcGoogle.listFilesLicencia(cedula,this.administraciones[0].nit).toPromise();

      // 🔹 Si el backend devuelve "data" vacía → mostrar mensaje del backend
      if (!res || !Array.isArray(res.data) || res.data.length === 0) {
        Swal.fire({
          icon: 'info',
          title: 'Sin digitales cargados',
          text: res?.message || `La persona con cédula: ${cedula}, No tiene soportes digitales cargados.`,
          confirmButtonText: 'Entendido',
          customClass: { confirmButton: 'btn btn-primary' },
          buttonsStyling: false
        });
        return;
      }

      // 🔹 Transformar archivos a formato usable
      this.files = await Promise.all(
        res.data.map(async (file: any) => {
          const signedUrl = await this.gpcGoogle.getSignedUrl(file.path).toPromise();
          let type = 'other';
          if (file.contentType?.includes('image')) type = 'image';
          else if (file.contentType?.includes('pdf')) type = 'pdf';

          return {
            name: file.name,
            url: signedUrl.url,
            type
          };
        })
      );

      // 🔹 Mostrar modal con el primer archivo
      this.currentFileIndex = 0;
      this.previewFile = this.files[0];
      const modalEl = document.getElementById('filePreviewModal');
      if (modalEl) {
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
      }

    } catch (err) {
      console.error('Error cargando archivos:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un problema al cargar la licencia.',
        confirmButtonText: 'Cerrar',
        customClass: { confirmButton: 'btn btn-danger' },
        buttonsStyling: false
      });
    } finally {
      this.loading = false;
    }
  }

  nextFile() {
    if (this.currentFileIndex < this.files.length - 1) {
      this.currentFileIndex++;
      this.previewFile = this.files[this.currentFileIndex];
    }
  }

  prevFile() {
    if (this.currentFileIndex > 0) {
      this.currentFileIndex--;
      this.previewFile = this.files[this.currentFileIndex];
    }
  }
  openPreview(file: any) {
    this.previewFile = file;
    const modalEl = document.getElementById('filePreviewModal');
    if (modalEl) {
      const modal = new bootstrap.Modal(modalEl);
      modal.show();
    }
  }

   private cargarDataAdmin():void{
  this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
        console.log(data);
          this.administraciones = data;       
  
;        
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
 }



}


